import React from "react";
import SelectNew from "./SelectNew";

type AsyncSelectProps = React.ComponentProps<typeof SelectNew> & {
  onStartSearching?: (inputValue: string) => any;
};

const AsyncSelect = ({
  onStartSearching,
  loadOptions,
  search,
  isSearchable,
  ...props
}: AsyncSelectProps) => {
  return (
    <SelectNew
      {...props}
      search={search ?? isSearchable ?? true}
      loadOptions={loadOptions || onStartSearching}
    />
  );
};

export default AsyncSelect;
